export const SET_FILTERS = 'recruitment/SET_FILTERS'
export const SET_FILTERS_FIELD = 'recruitment/SET_FILTERS_FIELD'
export const SET_PAGE = 'recruitment/SET_PAGE'
export const SET_NEXT_PAGE = 'recruitment/SET_NEXT_PAGE'
export const SET_PREV_PAGE = 'recruitment/SET_PREV_PAGE'
export const SET_PAGE_SIZE = 'recruitment/SET_PAGE_SIZE'

export const UPDATE_EVENTS = 'recruitment/UPDATE_EVENTS'
export const UPDATE_ACTION_HISTORY = 'recruitment/UPDATE_ACTION_HISTORY'
export const UPDATE_SEARCH_RESULTS = 'recruitment/UPDATE_SEARCH_RESULTS'

/* Admin panel actions */
export const ADMIN_UPDATE_RECRUITERS = 'recruitment/ADMIN_UPDATE_RECRUITERS'
export const ADMIN_UPDATE_SEARCH_RESULTS =
    'recruitment/ADMIN_UPDATE_SEARCH_RESULTS'
export const ADMIN_UPDATE_USER = 'recruitment/ADMIN_GRANT_ACCESS'
